// 用户信息接口
export interface UserInfo {
  id: number
  name: string
  email: string
  avatar?: string
  phone?: string
}

// 用户状态接口
export interface UserState {
  token: string | null
  userInfo: UserInfo | null
  isLoggedIn: boolean
}

// 初始状态
const state: UserState = {
  token: localStorage.getItem('auth_token'),
  userInfo: null,
  isLoggedIn: !!localStorage.getItem('auth_token')
}

// 获取器
const getters = {
  token: (state: UserState) => state.token,
  userInfo: (state: UserState) => state.userInfo,
  isLoggedIn: (state: UserState) => state.isLoggedIn
}

// 操作
const actions = {
  setToken ({ commit }: any, token: string) {
    commit('SET_TOKEN', token)
  },

  setUserInfo ({ commit }: any, userInfo: UserInfo) {
    commit('SET_USER_INFO', userInfo)
  },

  logout ({ commit }: any) {
    commit('LOGOUT')
  }
}

// 变更
const mutations = {
  SET_TOKEN (state: UserState, token: string) {
    state.token = token
    state.isLoggedIn = true
    localStorage.setItem('auth_token', token)
  },

  SET_USER_INFO (state: UserState, userInfo: UserInfo) {
    state.userInfo = userInfo
  },

  LOGOUT (state: UserState) {
    state.token = null
    state.userInfo = null
    state.isLoggedIn = false
    localStorage.removeItem('auth_token')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
